<template lang="html">
    <v-container grid-list-md text-xs-center>
      <v-layout align-center justify-center row fill-height style="height: 100vh;">
        <v-flex xs12 sm9 md5 lg3>

          <login v-if="!showRecover" @toggle="toggleCard()" />

          <recover v-else-if="showRecover" @toggle="toggleCard()" />

        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import login from '@/components/Auth/login'
import recover from '@/components/Auth/recover'
export default {
  data: function () {
    return {
      showRecover: false
    }
  },
  methods: {
    toggleCard: function () {
      this.showRecover = !this.showRecover
    }
  },
  components:{
    login,
    recover
  }
}
</script>

<style lang="css" scoped>
</style>
